import { defineComponent } from 'vue';
import { toasts, removeToast } from '../../../composables/useToast';
const POSITION_CLASSES = {
    'top-start': 'top-0 start-0',
    'top-center': 'top-0 start-50 translate-middle-x',
    'top-end': 'top-0 end-0',
    'middle-start': 'top-50 start-0 translate-middle-y',
    'middle-center': 'top-50 start-50 translate-middle',
    'middle-end': 'top-50 end-0 translate-middle-y',
    'bottom-start': 'bottom-0 start-0',
    'bottom-center': 'bottom-0 start-50 translate-middle-x',
    'bottom-end': 'bottom-0 end-0',
};
const LIGHT_TYPES = ['warning', 'light'];
export default defineComponent({
    // #region Class
    name: 'g-toast-container',
    // #endregion
    // #region Data
    data() {
        return {
            toasts,
            now: Date.now(),
            _ticker: null,
        };
    },
    // #endregion
    // #region Computed
    computed: {
        hasBlockingToast() {
            return this.toasts.some(t => t.blocking);
        },
        groupedToasts() {
            const groups = {};
            for (const t of this.toasts) {
                if (!groups[t.position])
                    groups[t.position] = [];
                groups[t.position].push(t);
            }
            return groups;
        },
    },
    // #endregion
    // #region Lifecycle
    mounted() {
        this._ticker = setInterval(() => { this.now = Date.now(); }, 1_000);
    },
    unmounted() {
        if (this._ticker)
            clearInterval(this._ticker);
    },
    // #endregion
    // #region Methods
    methods: {
        removeToast(id) {
            removeToast(id);
        },
        timeAgo(timestamp) {
            const diff = Math.floor((this.now - timestamp) / 1000);
            if (diff < 60)
                return 'gerade eben';
            const mins = Math.floor(diff / 60);
            if (mins < 60)
                return `vor ${mins} Min.`;
            const hours = Math.floor(mins / 60);
            if (hours < 24)
                return `vor ${hours} Std.`;
            const days = Math.floor(hours / 24);
            return `vor ${days} Tag${days !== 1 ? 'en' : ''}`;
        },
        positionClass(pos) {
            return POSITION_CLASSES[pos] ?? '';
        },
        toastClass(toast) {
            return `text-bg-${toast.type}`;
        },
        headerClass(toast) {
            const isLight = LIGHT_TYPES.includes(toast.type);
            return isLight ? '' : `text-bg-${toast.type} border-bottom border-white border-opacity-25`;
        },
        closeBtnClass(toast) {
            return LIGHT_TYPES.includes(toast.type) ? '' : 'btn-close-white';
        },
        defaultActionVariant(toast) {
            return LIGHT_TYPES.includes(toast.type) ? 'outline-secondary' : 'outline-light';
        },
        countdownRemaining(toast) {
            if (!toast.countdownEnd)
                return 0;
            return Math.max(0, Math.ceil((toast.countdownEnd - this.now) / 1000));
        },
        countdownPercent(toast) {
            if (!toast.countdownEnd || !toast.countdown)
                return 100;
            const remaining = Math.max(0, toast.countdownEnd - this.now);
            return (remaining / (toast.countdown * 1000)) * 100;
        },
        countdownBadgeClass(toast) {
            return LIGHT_TYPES.includes(toast.type) ? 'toast-countdown-badge--dark' : 'toast-countdown-badge--light';
        },
        countdownBarClass(toast) {
            return LIGHT_TYPES.includes(toast.type) ? 'toast-countdown-bar--dark' : 'toast-countdown-bar--light';
        },
    },
    // #endregion
});
